import { render } from "./ModModifiElimAct.vue?vue&type=template&id=0977df6e&scoped=true"
import script from "./ModModifiElimAct.vue?vue&type=script&lang=js"
export * from "./ModModifiElimAct.vue?vue&type=script&lang=js"

import "./ModModifiElimAct.vue?vue&type=style&index=0&id=0977df6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0977df6e"]])

export default __exports__